import { VotacaoParticipanteItem } from "core/features/assembleia/typings";
import { defaultContentMapperXlsx } from "infra/packages/json-as-xlsx/index";
import xlsx, { IColumn, IContent, IJsonSheet, ISettings } from "json-as-xlsx";

export function exportExcelVotacaoParticipantes({
  nomeVotacao,
  data,
}: {
  nomeVotacao: string;
  data: VotacaoParticipanteItem[];
}) {
  const settings: ISettings = {
    fileName: `${nomeVotacao} - Participantes`,
    extraLength: 3,
    writeOptions: {},
  };

  const columns = getColumns();

  const sheets: IJsonSheet[] = [];

  sheets.push({
    sheet: "Participantes",
    columns: columns,
    content: data.map(defaultContentMapperXlsx),
  });

  xlsx(sheets, settings);
}

function getColumns() {
  const columns: IColumn[] = [];

  columns.push({
    label: "Nome",
    value: (row: IContent) =>
      (row as unknown as VotacaoParticipanteItem).pessoa.nome!,
  });

  columns.push({
    label: "Adicionado?",
    value: (row: IContent) =>
      (row as unknown as VotacaoParticipanteItem).dataCheckin
        ? "Sim"
        : "Não",
  });

  columns.push({
    label: "Peso total (adimplente)",
    value: (row: IContent) =>
      {
       const peso = (row as unknown as VotacaoParticipanteItem).unidades.reduce((acc, next) => {
        acc += next.inadimplente ? 0 : next.peso;
        return acc;
       }, 0)

       return peso;
      }
  });

  columns.push({
    label: "Unidade(s)",
    value: (row: IContent) => {
      const unidadesString = (
        row as unknown as VotacaoParticipanteItem
      ).unidades
        .map((u) =>
          u.blocoQuadra
            ? `${u.numero} / Bloco ${u.blocoQuadra.nome}, peso: ${u.peso}${
                u.inadimplente ? " (inadimplente)" : ""
              }`
            : `${u.numero}, peso: ${u.peso}${
                u.inadimplente ? " (inadimplente)" : ""
              }`
        )
        .join("\n");

      return unidadesString;
    },
  });

  return columns;
}
